import React from "react";

class VolverHandler extends React.Component {
  componentDidMount() {
    const { steps, triggerNextStep } = this.props;

    const legislacion = steps["legislacionOptions"]?.value;
    const normativa = steps["normativaOptions"]?.value;

    if (legislacion && legislacion !== "volver") {
      triggerNextStep({ trigger: "legislacionOptions" });
    } else if (normativa && normativa !== "volver") {
      triggerNextStep({ trigger: "normativaOptions" });
    } else {
      triggerNextStep({ trigger: "mainmenu" });
    }
  }

  render() {
    return null;
  }
}

export default VolverHandler;
